import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const Dashboard = () => import('@/views/Dashboard')
const Stats = () => import('@/views/Stats')

const ListOperations = () => import('@/views/operations/ListOperations')
const AddOperations = () => import('@/views/operations/AddOperations')
const ViewOperations = () => import('@/views/operations/ViewOperations')

const ListTasks = () => import('@/views/tasks/ListTasks')
const AddTasks = () => import('@/views/tasks/AddTasks')
const EditTasks = () => import('@/views/tasks/EditTasks')

const ListTools = () => import('@/views/tools/ListTools')
const AddTools = () => import('@/views/tools/AddTools')
const EditTools = () => import('@/views/tools/EditTools')

const ListPlaces = () => import('@/views/places/ListPlaces')
const AddPlaces = () => import('@/views/places/AddPlaces')
const EditPlaces = () => import('@/views/places/EditPlaces')

const ListPeople = () => import('@/views/people/ListPeople')
const AddPeople = () => import('@/views/people/AddPeople')
const EditPeople = () => import('@/views/people/EditPeople')

const Settings = () => import('@/views/settings/ListSettings')


// Views - Pages
const PrivacyPolicy = () => import('@/views/PrivacyPolicy')
const Page404 = () => import('@/views/Page404')
const Page500 = () => import('@/views/Page500')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/inicio',
      name: 'Home',
      
      component: TheContainer,
      children: [
        {
          path: 'inicio',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'operacoes',
          redirect: '/operacoes/lista',
          name: 'ListOperations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'ListOperations',
              component: ListOperations
            },
            {
              path: 'adicionar',
              name: 'AddOperations',
              component: AddOperations
            },
            {
              path: 'ver',
              name: 'ViewOperations',
              component: ViewOperations
            },
          ]
        },
        {
          path: '/estatisticas',
          name: 'Stats',
          component: Stats
        },
        {
          path: 'tarefas',
          redirect: '/tarefas/lista',
          name: 'ListTasks',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'ListTasks',
              component: ListTasks
            },
            {
              path: 'adicionar',
              name: 'AddTasks',
              component: AddTasks
            },
            {
              path: 'editar',
              name: 'EditTasks',
              component: EditTasks
            },
          ]
        },
        {
          path: 'ferramentas',
          redirect: '/ferramentas/lista',
          name: 'ListTools',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'ListTools',
              component: ListTools
            },
            {
              path: 'adicionar',
              name: 'AddTools',
              component: AddTools
            },
            {
              path: 'editar',
              name: 'EditTools',
              component: EditTools
            },
          ]
        },
        {
          path: 'locais',
          redirect: '/locais/lista',
          name: 'ListPlaces',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'ListPlaces',
              component: ListPlaces
            },
            {
              path: 'adicionar',
              name: 'AddPlaces',
              component: AddPlaces
            },
            {
              path: 'editar',
              name: 'EditPlaces',
              component: EditPlaces
            },
          ]
        },
        {
          path: 'pessoas',
          redirect: '/pessoas/lista',
          name: 'ListPeople',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'ListPeople',
              component: ListPeople
            },
            {
              path: 'adicionar',
              name: 'AddPeople',
              component: AddPeople
            },
            {
              path: 'editar',
              name: 'EditPeople',
              component: EditPeople
            },
          ]
        },
        {
          path: 'definicoes',
          name: 'Settings',
          component: Settings
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/politica',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },    
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

